import Image from '@react/shared/components/Image';
import cx from 'classnames';
import React from 'react';
import FaqBox from 'sly/hubPage/components/HubDynamicContent/DynamicFaqBlock';
import ThreeColumnValue from 'sly/hubPage/components/HubDynamicContent/ThreeColumnValue';
import { HowItWorksProps } from 'sly/marketingPages/HowItWorks.types';
import { Heading } from 'sly/system';

function HowItWorks({
  imgWithItem,
  getListWithIcons,
  getFaqList,
}: HowItWorksProps) {
  const listWithImg = imgWithItem
    ? imgWithItem.flatMap((element) => element.imgWithTitle)
    : [];
  return (
    <>
      {!!listWithImg?.length && (
        <div
          className={cx(
            'my-xxl mx-m justify-center',
            'flex-col items-baseline',
            'md:my-xxxl md:mx-l',
            'lg:my-xxxl lg:mx-auto lg:w-[64.5rem] lg:items-start'
          )}
          data-tp-id='gen-Flex-947b5121-ead3-47b9-baf9-cc804055c5f6'
        >
          {listWithImg?.map((item, index) => (
            <div
              className={cx(
                'flex w-full flex-col',
                listWithImg?.length - 1 !== index && 'mb-xxl md:mb-xxxl',
                'md:justify-evenly',
                index & 1 ? 'md:flex-row' : 'md:flex-row-reverse'
              )}
              key={item.id}
              data-tp-id='gen-Flex-da21231d-41e1-49b3-b553-06c08d940367'
            >
              <div
                className={cx(
                  'relative',
                  'h-[20.5rem] w-[calc(100%_-_1rem)]',
                  'mb-xl p-0',
                  index === 1 && 'ml-auto',
                  'md:ml-0 md:h-[20.5rem] md:w-[20.5rem]',
                  `lg:w-[28.5rem]`,
                  `rounded-lg lg:h-[28.5rem]`
                )}
                style={{
                  boxShadow:
                    index & 1
                      ? `-1rem 1rem 0 0 ${item?.backgroundColor}`
                      : `1rem 1rem 0 0 ${item?.backgroundColor}`,
                }}
                data-tp-id='gen-Block-cdd332dc-527b-4619-9f6c-df67c654eb3c'
              >
                <Image
                  className={cx('h-full w-full')}
                  path={item?.srcImg?.path}
                  loading='eager'
                  alt={item.title}
                  data-tp-id='gen-Image-3868ff20-b743-4cc5-8c32-95183a81cc0b'
                  objectFit='cover'
                  layout='fill'
                  priority={index === 0}
                />
              </div>
              <div
                className={cx(
                  'flex flex-col justify-center',
                  'md:w-[20.5rem]',
                  `lg:w-[28.5rem]`
                )}
                data-tp-id='gen-Flex-e3ee831c-2983-4f3d-859d-92c30d83099a'
              >
                <Heading
                  className='font-t-l mb-m'
                  data-tp-id='gen-Heading-c0c36156-46a5-46ae-8823-606ae9533e64'
                >
                  {item.title}
                </Heading>
                <p
                  className='font-b-l'
                  data-tp-id='gen-Paragraph-a1eab42a-1cc4-4335-b444-b851805c7298'
                >
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
      <hr data-tp-id='gen-Hr-e28306d7-ce4d-4918-88eb-b99d7c17a672' />
      <ThreeColumnValue getListWithIcons={getListWithIcons} />
      <hr data-tp-id='gen-Hr-0de16806-d379-47ce-98e0-bd73fd07bbc1' />
      {getFaqList?.length && <FaqBox faqs={getFaqList} />}
    </>
  );
}

export default HowItWorks;
